import 'css-chunksrc/client/scenes/projectMembersListingConfiguration/form/columns/form/styles.scss';export default {
  "input": "_input_4xvij_1",
  "listRoot": "_listRoot_4xvij_14",
  "list": "_list_4xvij_14",
  "item": "_item_4xvij_30",
  "icon": "_icon_4xvij_43",
  "timeSheetIcon": "_timeSheetIcon_4xvij_51",
  "name": "_name_4xvij_56"
};